import React, { useEffect, useState } from 'react';
import update from 'immutability-helper';

import { AddEditTrustedContact } from 'managers/Users.js';
import MultipleListField from 'views/MultipleListField.js';
import Request from 'files/Request.js';
import Views from 'views/Main.js';
import Abstract from 'classes/Abstract';

const ContactList = ({ onChange, utils, value }) => {

    const [contacts, setContacts] = useState([]);
    const [values, setValues] = useState([]);

    const onExistingUserClick = target => {
        utils.layer.open({
            abstract: Abstract.create({
                object: target,
                type: 'trusted_contacts'
            }),
            Component: AddEditTrustedContact.bind(this, { 
                isNewTarget: false,
                onChange: result => {

                    // update values for contacts list
                    let targets = contacts.map(item => item.id === target.id ? result : item);
                    setContacts(targets);

                    // update internal state for selected values
                    let next = values.map(item => item.id === target.id ? result : item);
                    setValues(next);

                    // notify subscribers of data change
                    if(typeof(onChange) === 'function') {
                        onChange(next);
                    }
                }
            }),
            id: `trusted_contacts.${target.id}`
        });
    }

    const onNewUserClick = () => {
        utils.layer.open({
            abstract: Abstract.create({
                object: {},
                type: 'trusted_contacts'
            }),
            Component: AddEditTrustedContact.bind(this, { 
                isNewTarget: true,
                onChange: result => {

                    // update values for contacts list
                    setContacts(targets => {
                        return update(targets, {
                            $push: [result]
                        });
                    });

                    // update internal state for selected values
                    let next = values.concat([result]);
                    setValues(next);

                    // notify subscribers of data change
                    if(typeof(onChange) === 'function') {
                        onChange(next);
                    }
                }
            }),
            id: 'new_trusted_contact'
        });
    }

    const onSelectionChange = items => {

        // prepare list of ids for selection and update local state with selected targets
        let ids = items.map(item => item.id);
        let next = contacts.filter(contact => ids.includes(contact.id));
        setValues(next);

        // notify subscriberes of data change
        if(typeof(onChange) === 'function') {
            onChange(next);
        }
    }

    const getContacts = () => {
        return contacts.map(contact => ({
            id: contact.id,
            title: contact.full_name
        }));
    }

    const getValues = () => {
        return values.map(contact => ({
            id: contact.id,
            title: contact.full_name
        }));
    }

    const fetchContacts = async () => {
        try {

            // submit request to server
            let { trusted_contacts } = await Request.get(utils, '/users/', {
                type: 'trusted_contacts'
            });

            setContacts(trusted_contacts);

        } catch(e) {
            utils.alert.error({
                error: e,
                message: `There was an issue retrieving your Trusted Contacts list. ${e.message || 'An unknown error occurred'}`,
                origin: 'contacts_list.fetch_contacts'
            });
        }
    } 

    useEffect(() => {
        if(contacts?.length > 0) {
            setValues(contacts.filter(contact => value?.includes(contact.id)));
        }
    }, [contacts, value]);

    useEffect(() => {
        fetchContacts();
    }, []);
    
    return (
        <MultipleListField
        items={getContacts()}
        onAddNew={onNewUserClick}
        onChange={onSelectionChange}
        onRenderResult={(item, index, items, onRemoveItem) => {
            return (
                <div key={index}>
                    {Views.row({
                        bottomBorder: index !== items.length - 1,
                        hideOnClickArrow: true,
                        label: item.title,
                        onClick: onExistingUserClick.bind(this, item),
                        value: (
                            <img
                            className={'text-button'}
                            onClick={onRemoveItem.bind(this, index)}
                            src={'images/delete-red-icon.png'}
                            style={{
                                height: 20,
                                objectFit: 'contain',
                                width: 20
                            }} />
                        )
                    })}
                </div>
            )
        }}
        value={getValues()} />
    )
}

export default ContactList;
